import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/views/index';
import commodityOrder from '@/views/commodityOrder';
import courseDetail from '@/views/courseDetail';
import courseList from '@/views/courseList';
import myCard from '@/views/myCard';
import myCourse from '@/views/myCourse';
import myCourseDetail from '@/views/myCourseDetail';
import myCoursePlay from '@/views/myCoursePlay';
import onlineExam from '@/views/onlineExam';
import orderDetail from '@/views/orderDetail';
import personalCenter from '@/views/personalCenter';
import playDetail from '@/views/playDetail';
import remoteEducation from '@/views/remoteEducation';
import userProfiles from '@/views/userProfiles';
import evaluateOrder from '@/views/evaluateOrder';
import evaluateCourse from '@/views/evaluateCourse';
import joinUs from '@/views/joinUs';
import editInfo from '@/views/editInfo';
import message from '@/views/message';
import playRecord from '@/views/playRecord';
import recordDetail from '@/views/recordDetail';
import testOnline from '@/views/testOnline';
import testOffline from '@/views/testOffline';
import resultOnline from '@/views/resultOnline';
import resultOffline from '@/views/resultOffline';
import studyRoom from '@/views/studyRoom';
import commodityDetail from '@/views/commodityDetail';
import shoppingCart from '@/views/shoppingCart';
import shoppingPay from '@/views/shoppingPay';
import schoolShow from '@/views/schoolShow';
import showDetail from '@/views/showDetail';

Vue.use (Router);
const router = new Router ({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: '首页',
      },
    },
    {
      path: '/commodityOrder',
      name: 'commodityOrder',
      component: commodityOrder,
      meta: {
        title: '',
      },
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      component: courseDetail,
      meta: {
        title: '',
      },
    },
    {
      path: '/courseList',
      name: 'courseList',
      component: courseList,
      meta: {
        title: '',
      },
    },
    {
      path: '/myCard',
      name: 'myCard',
      component: myCard,
      meta: {
        title: '',
      },
    },
    {
      path: '/myCourse',
      name: 'myCourse',
      component: myCourse,
      meta: {
        title: '',
      },
    },
    {
      path: '/myCourseDetail',
      name: 'myCourseDetail',
      component: myCourseDetail,
      meta: {
        title: '',
      },
    },
    {
      path: '/myCoursePlay',
      name: 'myCoursePlay',
      component: myCoursePlay,
      meta: {
        title: '',
      },
    },
    {
      path: '/onlineExam',
      name: 'onlineExam',
      component: onlineExam,
      meta: {
        title: '',
      },
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        title: '',
      },
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: personalCenter,
      meta: {
        title: '',
      },
    },
    {
      path: '/playDetail',
      name: 'playDetail',
      component: playDetail,
      meta: {
        title: '',
      },
    },
    {
      path: '/remoteEducation',
      name: 'remoteEducation',
      component: remoteEducation,
      meta: {
        title: '',
      },
    },
    {
      path: '/userProfiles',
      name: 'userProfiles',
      component: userProfiles,
      meta: {
        title: '',
      },
    },
    {
      path: '/evaluateOrder',
      name: 'evaluateOrder',
      component: evaluateOrder,
      meta: {
        title: '',
      },
    },
    {
      path: '/evaluateCourse',
      name: 'evaluateCourse',
      component: evaluateCourse,
      meta: {
        title: '',
      },
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs,
      meta: {
        title: '',
      },
    },
    {
      path: '/editInfo',
      name: 'editInfo',
      component: editInfo,
      meta: {
        title: '',
      },
    },
    {
      path: '/message',
      name: 'message',
      component: message,
      meta: {
        title: '',
      },
    },
    {
      path: '/playRecord',
      name: 'playRecord',
      component: playRecord,
      meta: {
        title: '',
      },
    },
    {
      path: '/recordDetail',
      name: 'recordDetail',
      component: recordDetail,
      meta: {
        title: '',
      },
    },
    {
      path: '/testOnline',
      name: 'testOnline',
      component: testOnline,
      meta: {
        title: '',
      },
    },
    {
      path: '/testOffline',
      name: 'testOffline',
      component: testOffline,
      meta: {
        title: '',
      },
    },
    {
      path: '/resultOnline',
      name: 'resultOnline',
      component: resultOnline,
      meta: {
        title: '',
      },
    },
    {
      path: '/resultOffline',
      name: 'resultOffline',
      component: resultOffline,
      meta: {
        title: '',
      },
    },
    {
      path: '/studyRoom',
      name: 'studyRoom',
      component: studyRoom,
      meta: {
        title: '',
      },
    },
    {
      path: '/commodityDetail',
      name: 'commodityDetail',
      component: commodityDetail,
      meta: {
        title: '',
      },
    },
    {
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: shoppingCart,
      meta: {
        title: '',
      },
    },
    {
      path: '/shoppingPay',
      name: 'shoppingPay',
      component: shoppingPay,
      meta: {
        title: '',
      },
    },
    {
      path: '/schoolShow',
      name: 'schoolShow',
      component: schoolShow,
      meta: {
        title: '',
      },
    },
    {
      path: '/showDetail',
      name: 'showDetail',
      component: showDetail,
      meta: {
        title: '',
      },
    },
    // h5页面
    {
      path: '/mb_index',
      name: 'mb_index',
      component: () => import ('../views/mobilePage/home.vue'),
    },
    {
      path: '/mb_schoolIntro',
      name: 'mb_schoolIntro',
      component: () => import ('../views/mobilePage/school-intro.vue'),
    },
    {
      path: '/mb_examinationRegist',
      name: 'mb_examinationRegist',
      component: () => import ('../views/mobilePage/examination-regist.vue'),
    },
    {
      path: '/mb_examSearch',
      name: 'mb_examSearch',
      component: () => import ('../views/mobilePage/exam-search.vue'),
    },
    {
      path: '/mb_login',
      name: 'login',
      component: () => import ('../views/mobilePage/login.vue'),
    },
    {
      path: '/mb_wxLogin',
      name: 'mb_wxLogin',
      component: () => import ('../views/mobilePage/wx-login.vue'),
    },
    {
      path: '/mb_capacityTrain',
      name: 'mb_capacityTrain',
      component: () => import ('../views/mobilePage/capacity-train.vue'),
    },
    {
      path: '/mb_capacityTrainSearch',
      name: 'capacityTrainSearch',
      component: () => import ('../views/mobilePage/capacity-train-search.vue'),
    },
    {
      path: '/mb_courseDetail',
      name: 'mb_courseDetail',
      component: () => import ('../views/mobilePage/course-detail.vue'),
    },
    {
      path: '/mb_userProfile',
      name: 'mb_userProfile',
      component: () => import ('../views/mobilePage/user-profile.vue'),
    },
    // 远程教育
    {
      path: '/mb_remoteEducation',
      name: 'mb_remoteEducation',
      component: () => import ('../views/mobilePage/remote-education.vue'),
    },
    {
      path: '/mb_remoteEducationSearch',
      name: 'mb_remoteEducationSearch',
      component: () =>
        import ('../views/mobilePage/remote-education-search.vue'),
    },
    // 直播详情
    {
      path: '/mb_playDetail',
      name: 'mb_playDetail',
      component: () => import ('../views/mobilePage/play-detail.vue'),
    },
    // 付款信息
    {
      path: '/mb_pay',
      name: 'mb_pay',
      component: () => import ('../views/mobilePage/pay.vue'),
    },
    // 现金支付
    {
      path: '/mb_cashPay',
      name: 'mb_cashPay',
      component: () => import ('../views/mobilePage/cash-pay.vue'),
    },
    // 对公转账
    {
      path: '/mb_transferAccount',
      name: 'mb_transferAccount',
      component: () => import ('../views/mobilePage/transfer-account.vue'),
    },
    // 支付结果
    {
      path: '/mb_payResult',
      name: 'mb_payResult',
      component: () => import ('../views/mobilePage/pay-result.vue'),
    },
    // 个人中心
    {
      path: '/mb_personCenter',
      name: 'mb_personCenter',
      component: () =>
        import ('../views/mobilePage/personCenter/person-center.vue'),
    },
    // 线下考试
    {
      path: '/mb_offlineExam',
      name: 'offlineExam',
      component: () => import ('../views/mobilePage/offlineExam.vue'),
    },
    // 报名成功
    {
      path: '/mb_registSuccess',
      name: 'mb_registSuccess',
      component: () => import ('../views/mobilePage/regist-success.vue'),
    },
    // 问卷
    {
      path: '/mb_questionnaire',
      name: 'mb_questionnaire',
      component: () => import ('../views/mobilePage/questionnaire.vue'),
    },
    // 评论列表
    {
      path: '/mb_comment',
      name: 'mb_comment',
      component: () => import ('../views/mobilePage/comment.vue'),
    },
    // 书斋
    {
      path: '/mb_studyRoom',
      name: 'mb_studyRoom',
      component: () => import ('../views/mobilePage/study-room.vue'),
    },
    // 个人信息编辑
    {
      path: '/mb_editInfo',
      name: 'mb_editInfo',
      component: () =>
        import ('../views/mobilePage/personCenter/edit-info.vue'),
    },
    // 发送验证码
    {
      path: '/mb_code',
      name: 'mb_code',
      component: () => import ('../views/mobilePage/personCenter/code.vue'),
    },
    // 修改手机号
    {
      path: '/mb_editPhone',
      name: 'mb_editPhone',
      component: () =>
        import ('../views/mobilePage/personCenter/edit-phone.vue'),
    },
    // 修改成功
    {
      path: '/mb_editSuccess',
      name: 'mb_editSuccess',
      component: () =>
        import ('../views/mobilePage/personCenter/edit-success.vue'),
    },
    // 我的课程
    {
      path: '/mb_myCourse',
      name: 'mb_myCourse',
      component: () =>
        import ('../views/mobilePage/personCenter/my-course.vue'),
    },
    // 课程评价
    {
      path: '/mb_evaluation',
      name: 'mb_evaluation',
      component: () =>
        import ('../views/mobilePage/personCenter/evaluation.vue'),
    },
    // 满意度调查表
    {
      path: '/mb_questionnaire',
      name: 'mb_questionnaire',
      component: () =>
        import ('../views/mobilePage/personCenter/questionnaire.vue'),
    },
    // 我的课程详情
    {
      path: '/mb_myCourseDetail',
      name: 'mb_myCourseDetail',
      component: () =>
        import ('../views/mobilePage/personCenter/course-detail.vue'),
    },
    // 线上视频
    {
      path: '/mb_onlineVideo',
      name: 'mb_onlineVideo',
      component: () =>
        import ('../views/mobilePage/personCenter/online-video.vue'),
    },
    // 日程表
    {
      path: '/mb_schedule',
      name: 'mb_schedule',
      component: () => import ('../views/mobilePage/personCenter/schedule.vue'),
    },
    // 荣誉殿堂
    {
      path: '/mb_honor',
      name: 'mb_honor',
      component: () => import ('../views/mobilePage/personCenter/honor.vue'),
    },
    // 我的证书
    {
      path: '/mb_myCertificate',
      name: 'mb_myCertificate',
      component: () =>
        import ('../views/mobilePage/personCenter/my-certificate.vue'),
    },
    // 我的订单
    {
      path: '/mb_myOrder',
      name: 'mb_myOrder',
      component: () => import ('../views/mobilePage/personCenter/my-order.vue'),
    },
    // 我的订单详情
    {
      path: '/mb_myOrderDetail',
      name: 'mb_myOrderDetail',
      component: () =>
        import ('../views/mobilePage/personCenter/my-order-detail.vue'),
    },
    // 物流信息
    {
      path: '/mb_logistics',
      name: 'mb_logistics',
      component: () =>
        import ('../views/mobilePage/personCenter/logistics.vue'),
    },
    // 申请开票
    {
      path: '/mb_lnvoicing',
      name: 'mb_lnvoicing',
      component: () =>
        import ('../views/mobilePage/personCenter/lnvoicing.vue'),
    },
    // 直播记录
    {
      path: '/mb_playRecord',
      name: 'mb_playRecord',
      component: () =>
        import ('../views/mobilePage/personCenter/play-record.vue'),
    },
    // 书斋商品详情
    {
      path: '/mb_studyDetail',
      name: 'mb_studyDetail',
      component: () => import ('../views/mobilePage/study-detail.vue'),
    },
    // 购物车
    {
      path: '/mb_shopCar',
      name: 'mb_shopCar',
      component: () => import ('../views/mobilePage/shop-car.vue'),
    },
    // 直播订单详情
    {
      path: '/mb_playOrderDetail',
      name: 'mb_playOrderDetail',
      component: () =>
        import ('../views/mobilePage/personCenter/play-order-detail.vue'),
    },
    // 加入我们
    {
      path: '/mb_joinUs',
      name: 'mb_joinUs',
      component: () => import ('../views/mobilePage/personCenter/join-us.vue'),
    },
    // 收货地址
    {
      path: '/mb_address',
      name: 'mb_address',
      component: () => import ('../views/mobilePage/personCenter/address.vue'),
    },
    // 新增地址
    {
      path: '/mb_addAddress',
      name: 'mb_addAddress',
      component: () =>
        import ('../views/mobilePage/personCenter/add-address.vue'),
    },
    // 消息通知
    {
      path: '/mb_message',
      name: 'mb_message',
      component: () => import ('../views/mobilePage/personCenter/message.vue'),
    },
    // 消息详情
    {
      path: '/mb_messageDetail',
      name: 'mb_messageDetail',
      component: () =>
        import ('../views/mobilePage/personCenter/message-detail.vue'),
    },
    // 优惠券
    {
      path: '/mb_coupon',
      name: 'mb_coupon',
      component: () => import ('../views/mobilePage/personCenter/coupon.vue'),
    },
    // 订单结算
    {
      path: '/mb_orderSettlement',
      name: 'mb_orderSettlement',
      component: () => import ('../views/mobilePage/order-settlement.vue'),
    },
    // 学校风采
    {
      path: '/mb_schoolStyle',
      name: 'mb_schoolStyle',
      component: () => import ('../views/mobilePage/school-style.vue'),
    },
    // 开票记录
    {
      path: '/mb_lnvoicingRecord',
      name: 'mb_lnvoicingRecord',
      component: () =>
        import ('../views/mobilePage/personCenter/lnvoicing-record.vue'),
    },
    // 开票记录详情
    {
      path: '/mb_lnvoicingDetail',
      name: 'mb_lnvoicingDetail',
      component: () =>
        import ('../views/mobilePage/personCenter/lnvoicing-detail.vue'),
    },
    // 学校风采搜索
    {
      path: '/mb_schoolStyleSearch',
      name: 'mb_schoolStyleSearch',
      component: () => import ('../views/mobilePage/school-style-search.vue'),
    },
    // 学校风采详情
    {
      path: '/mb_schoolStyleDetail',
      name: 'schoolStyleDetail',
      component: () => import ('../views/mobilePage/school-style-detail.vue'),
    },
    // 学校风采评论
    {
      path: '/mb_schoolStyleComment',
      name: 'mb_schoolStyleComment',
      component: () => import ('../views/mobilePage/school-style-comment.vue'),
    },
    // 选择地址
    {
      path: '/mb_addressSelect',
      name: 'mb_addressSelect',
      component: () => import ('../views/mobilePage/address-select.vue'),
    },
    // 新增地址
    {
      path: '/mb_newAddress',
      name: 'mb_newAddress',
      component: () => import ('../views/mobilePage/new-address.vue'),
    },
    // 线上考试
    {
      path: '/mb_onlineExam',
      name: 'mb_onlineExam',
      component: () => import ('../views/mobilePage/online-exam.vue'),
    },
    // 考试结果
    {
      path: '/mb_examResult',
      name: 'examResult',
      component: () => import ('../views/mobilePage/exam-result.vue'),
    },
  ],
});

let isMobile = localStorage.getItem ('projectType');
console.log (isMobile,"to.path name");
router.beforeEach (function (to, from, next) {
  console.log(to.path,"to.path")
  if (to.path.includes ('/mb_') && isMobile == 'Moperation') {
    next ();
  } else if (!to.path.includes ('/mb_') && isMobile == 'Moperation') {
    next ('/mb_index');
  } else if (to.path.includes ('/mb_') && isMobile == 'PCoperation') {
    next ('/');

  } else if (!to.path.includes ('/mb_') && isMobile == 'PCoperation') {
    next ();
    // next(to.path)
  }
  // next ();

});


const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call (this, location).catch (err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js